import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import PurchaseOrdersList from "./pages/PurchaseOrdersList";
import CreatePurchaseOrder from "./pages/CreatePurchaseOrder";
import VendorsPage from "./pages/VendorsPage";
import PODetailPage from "./pages/PODetailPage";
import NotificationsPage from "./pages/NotificationsPage";
import UserManagementPage from "./pages/UserManagementPage";
import WeavingProductionPage from "./pages/WeavingProductionPage";
import DyeingProductionPage from "./pages/DyeingProductionPage";
import StitchingProductionPage from "./pages/StitchingProductionPage";
import ProductionDashboardPage from "./pages/ProductionDashboardPage";
import ProductionTrackingPage from "./pages/ProductionTrackingPage";
import CreateWorkOrderPage from "./pages/CreateWorkOrderPage";
import AccessoriesPage from "./pages/AccessoriesPage";
import ReconciliationPage from "./pages/ReconciliationPage";
import YarnRequirementPage from "./pages/YarnRequirementPage";
import YarnRequirementAdminPage from "./pages/YarnRequirementAdminPage";
import SparePartsPage from "./pages/SparePartsPage";
import OnlineSalesPage from "./pages/OnlineSalesPage";
import PendingWorkPage from "./pages/PendingWorkPage";
import AttendancePage from "./pages/AttendancePage";
import ColorStorePage from "./pages/ColorStorePage";
import AccountsDashboardPage from "./pages/AccountsDashboardPage";
import Layout from "./components/Layout";
import { ThemeProvider } from "./components/ThemeProvider";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <ThemeProvider defaultTheme="light" storageKey="terrytrace-theme">
      <div className="App">
        <div className="noise-overlay" />
        <BrowserRouter>
          <Routes>
            <Route 
              path="/login" 
              element={
                isAuthenticated ? <Navigate to="/" replace /> : <LoginPage onLogin={handleLogin} />
              } 
            />
            <Route 
              path="/" 
              element={
                isAuthenticated ? <Layout user={user} onLogout={handleLogout} /> : <Navigate to="/login" replace />
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="purchase-orders" element={<PurchaseOrdersList />} />
              <Route path="purchase-orders/new" element={<CreatePurchaseOrder />} />
              <Route path="purchase-orders/:id" element={<PODetailPage />} />
              <Route path="purchase-orders/:id/edit" element={<CreatePurchaseOrder />} />
              <Route path="vendors" element={<VendorsPage />} />
              <Route path="users" element={<UserManagementPage />} />
              <Route path="weaving-production" element={<WeavingProductionPage />} />
              <Route path="dyeing-production" element={<DyeingProductionPage />} />
              <Route path="stitching-production" element={<StitchingProductionPage />} />
              <Route path="production-dashboard" element={<ProductionDashboardPage />} />
              <Route path="create-work-order" element={<CreateWorkOrderPage />} />
              <Route path="production-tracking/:id" element={<ProductionTrackingPage />} />
              <Route path="accessories" element={<AccessoriesPage />} />
              <Route path="spare-parts" element={<SparePartsPage />} />
              <Route path="online-sales" element={<OnlineSalesPage />} />
              <Route path="reconciliation/:woId" element={<ReconciliationPage />} />
              <Route path="yarn-requirement" element={<YarnRequirementPage />} />
              <Route path="yarn-requirement-admin" element={<YarnRequirementAdminPage />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="pending-work" element={<PendingWorkPage />} />
              <Route path="attendance" element={<AttendancePage />} />
              <Route path="color-store" element={<ColorStorePage />} />
              <Route path="accounts-dashboard" element={<AccountsDashboardPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
